import * as Api from "./api";

export async function LogFeature(featureId)
{
    try {
        await Api.postRequest(Api.URI_LogFeature + "/" + featureId);
    }
    catch (err) {
        console.error('Logging failed:', err);
    }
}

export const Features = {
    "HelpLink": 1
}